define('views/modules/questionnaire/edit/questionnaire-edit-form',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/form/textbox',
    'views/parts/form/choices',
    'views/parts/form/textarea',
    // templates
    'text!templates/modules/questionnaire/edit/questionnaire-edit-form.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VTextBox,
    VChoices,
    VTextarea,
    // templates
    TQuestionnaireEditForm
) {

    var VQuestionnaireEditForm = Backbone.View.extend({

        template: TQuestionnaireEditForm,

        // abstracting selectors out of the view logic
        regions: {
            root: '#questionnaire-edit-form',
            title: ".form-title",
            guidelines: ".form-guidelines",
            shared: ".form-shared",
            oneQuestionPerPage: ".form-one-question-per-page",
        },

        initialize: function() {
            this.view = {
                title: new VTextBox({ label: 'Title', labelposition: "top", attribute: 'title', model: this.model }),
                guidelines: new VTextarea({
                    label: 'questionnaire:Guidelines',
                    attribute: 'guidelines',
                    labelposition: 'outer',
                    rows: 2,
                    model: this.model
                }),
                shared: new VChoices({ label: "questionnaire:Share this questionnaire to all sub-groups", attribute: "shared", model: this.model }),
                oneQuestionPerPage: new VChoices({ label: "questionnaire:Show only one question per page", attribute: "oneQuestionPerPage", model: this.model }),
            };
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.title, zone.$title)
                .assign(view.guidelines, zone.$guidelines)
                .assign(view.shared, zone.$shared)
                .assign(view.oneQuestionPerPage, zone.$oneQuestionPerPage);

            return this;
        },

    });

    return VQuestionnaireEditForm;

});

